type TimelineDragSelectionOverlayProps = {
  startX: number
  endX: number
  top: number
  height: number
}

const TimelineDragSelectionOverlay = ({
  startX,
  endX,
  top,
  height,
}: TimelineDragSelectionOverlayProps) => {
  return (
    <g className='pointer-events-none'>
      <rect
        x={startX}
        y={top}
        width={Math.max(endX - startX, 1)}
        height={height}
        fill='var(--color-info-foreground)'
        opacity={0.25}
      />
      <line
        x1={startX}
        x2={startX}
        y1={top}
        y2={top + height}
        stroke='var(--color-accent-foreground)'
        strokeWidth={1}
      />
      <line
        x1={endX}
        x2={endX}
        y1={top}
        y2={top + height}
        stroke='var(--color-accent-foreground)'
        strokeWidth={1}
      />
    </g>
  )
}

export default TimelineDragSelectionOverlay
